module.exports = __webpack_public_path__ + "static/health-care-bg-45467a1b17786c9015c1f847e8eaebe6.png";